<template>
  <Drawer :drawer="drawer" :withHeader="false" :size="1240" @close="close">
    <div v-loading="loading" class="view">
      <div class="tag">
        <el-tabs v-model="active" type="card">
          <el-tab-pane label="基本信息" name="0"></el-tab-pane>
        </el-tabs>
        <i class="el-icon-close closeIcon" @click="close" />
      </div>
      <div class="panel panelActive1">
        <el-form ref="billInfo" :model="form" :rules="rules">
          <div class="panel2">
            <div v-if="!billType" class="panel-title">
              <svg-icon
                iconClass="panelTitle-icon"
                className="icon"
                :style="{ 'font-size': 20 }"
              />
              基本信息
            </div>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">主提单号</div>
                  <el-form-item prop="mblNo">
                    <el-input
                      v-model="form.mblNo"
                      size="small"
                      style="width: 220px"
                      @blur="changeMblNo"
                      @input="onInput('blNo')"
                    />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">分单号</div>
                  <el-form-item prop="blNo">
                    <el-input
                      v-model="form.blNo"
                      size="small"
                      style="width: 220px"
                    />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">目的国家</div>
                  <el-form-item prop="countryCode">
                    <el-select
                      v-model="form.countryCode"
                      filterable
                      style="width: 220px"
                      size="small"
                      placeholder="请选择目的国家"
                      @change="form.destinationHarborName = ''"
                    >
                      <el-option
                        v-for="item in addressDropCodeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">ETD - ETA</div>
                  <!-- <p>{{ mblDetail.etd }}</p> -->
                  <el-form-item prop="date">
                    <el-date-picker
                      v-model="form.date"
                      type="daterange"
                      unlink-panels
                      size="small"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd"
                      range-separator="-"
                      start-placeholder="请选择日期"
                      end-placeholder="请选择日期"
                      style="width: 220px"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">
                    {{ billType ? "始发机场" : "始发港" }}
                  </div>
                  <el-form-item prop="originHarborName">
                    <el-select
                      v-model="form.originHarborName"
                      size="small"
                      filterable
                      style="width: 220px"
                      placeholder="请选择始发港"
                    >
                      <el-option
                        v-for="(item, $index) in orginPortOptions"
                        :key="$index"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">
                    {{ billType ? "目的机场" : "目的港" }}
                  </div>
                  <el-form-item prop="destinationHarborName">
                    <el-select
                      v-model="form.destinationHarborName"
                      filterable
                      size="small"
                      style="width: 220px"
                      placeholder="请选择目的港"
                    >
                      <el-option
                        v-for="(item, $index) in destinPortOptions"
                        :key="$index"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="billType">
              <el-col :span="8">
                <div class="field">
                  <div class="label">提单件数(件)</div>
                  <el-form-item prop="qty">
                    <el-input
                      v-model="form.qty"
                      style="width: 220px"
                      size="small"
                      placeholder="请输入提单件数"
                      @input="onInput('qty')"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">方数(CBM)</div>
                  <el-form-item prop="weightCbm">
                    <el-input
                      v-model="form.weightCbm"
                      style="width: 220px"
                      size="small"
                      placeholder="请输入方数"
                      @input="onInput('weightCbm')"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">重量(KG)</div>
                  <el-form-item prop="weightKgs">
                    <el-input
                      v-model="form.weightKgs"
                      size="small"
                      style="width: 220px"
                      placeholder="请输入重量"
                      @input="onInput('weightKgs')"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="field">
                  <div class="label">收货人</div>
                  <el-form-item prop="consigneeName">
                    <el-select
                      v-model="form.consigneeName"
                      size="small"
                      style="width: 414px"
                      filterable
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in consigneeOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >

                        <span style="float: left">{{ item.label }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item?.address | formatStatusAddress }}
                          {{ item?.cityAddress | formatStatusAddress }}
                          {{ item?.provinceEnName | formatStatusAddress }}
                          {{ item?.countryName | formatStatusAddress }}
                          <strong>{{
                          item?.postcode ? item?.postcode : ""
                          }}</strong>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="field">
                  <div class="label">发货人</div>
                  <el-form-item prop="shipperName">
                    <el-select
                      v-model="form.shipperName"
                      size="small"
                      style="width: 414px"
                      filterable
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in shipperOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item?.address | formatStatusAddress }}
                          {{ item?.cityAddress | formatStatusAddress }}
                          {{ item?.provinceEnName | formatStatusAddress }}
                          {{ item?.countryName | formatStatusAddress }}
                          <strong>{{
                          item?.postcode ? item?.postcode : ""
                          }}</strong>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="field">
                  <div class="label">通知方</div>
                  <el-form-item prop="notifyPartyName">
                    <el-select
                      v-model="form.notifyPartyName"
                      size="small"
                      style="width: 414px"
                      filterable
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in notifyPartyOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item?.address | formatStatusAddress }}
                          {{ item?.cityAddress | formatStatusAddress }}
                          {{ item?.provinceEnName | formatStatusAddress }}
                          {{ item?.countryName | formatStatusAddress }}
                          <strong>{{
                          item?.postcode ? item?.postcode : ""
                          }}</strong>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="field">
                  <div class="label">制造商</div>
                  <el-form-item prop="manufacturerName">
                    <el-select
                      v-model="form.manufacturerName"
                      size="small"
                      style="width: 414px"
                      filterable
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in manufacturerOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item?.address | formatStatusAddress }}
                          {{ item?.cityAddress | formatStatusAddress }}
                          {{ item?.provinceEnName | formatStatusAddress }}
                          {{ item?.countryName | formatStatusAddress }}
                          <strong>{{
                          item?.postcode ? item?.postcode : ""
                          }}</strong>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="field">
                  <div class="label">进口商</div>
                  <el-form-item prop="importerName">
                    <el-select
                      v-model="form.importerName"
                      size="small"
                      style="width: 414px"
                      filterable
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in importerList"
                        :key="index"
                        :label="item.name"
                        :value="item.name"
                      >
                        <span style="float: left">{{ item.name }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item?.address | formatStatusAddress }}
                          {{ item?.cityAddress | formatStatusAddress }}
                          {{ item?.provinceEnName | formatStatusAddress }}
                          {{ item?.countryName | formatStatusAddress }}
                          <strong>{{
                          item?.postcode ? item?.postcode : ""
                          }}</strong>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="field">
                  <div class="label">最终收货人</div>
                  <el-form-item prop="ultimateConsigneeName">
                    <el-select
                      v-model="form.ultimateConsigneeName"
                      size="small"
                      style="width: 414px"
                      filterable
                      clearable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in ultimateConsigneeOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span
                          style="float: right; color: #8492a6; font-size: 13px"
                        >
                          {{ item?.address | formatStatusAddress }}
                          {{ item?.cityAddress | formatStatusAddress }}
                          {{ item?.provinceEnName | formatStatusAddress }}
                          {{ item?.countryName | formatStatusAddress }}
                          <strong>{{
                          item?.postcode ? item?.postcode : ""
                          }}</strong>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">清关方式</div>
                  <el-radio-group v-model="form.clearenceType" size="small">
                    <el-radio-button :label="0">自清</el-radio-button>
                    <el-radio-button :label="1">平台清</el-radio-button>
                  </el-radio-group>
                </div>
              </el-col>
              <template
                v-if="form.clearenceType === 1"
              ><el-col :span="8">
                 <div class="field">
                   <div class="label">接收DO邮箱</div>
                   <el-form-item prop="receivedDoEmail">
                     <el-input
                       v-model="form.receivedDoEmail"
                       placeholder="接收DO邮箱（可多条输入）以,隔开"
                       size="small"
                       style="width: 220px"
                     />
                   </el-form-item>
                 </div>
               </el-col>
                <el-col :span="8">
                  <div class="field">
                    <div class="label">接收DO公司名称</div>
                    <el-form-item prop="receivedDoCompany">
                      <el-input
                        v-model="form.receivedDoCompany"
                        size="small"
                        style="width: 220px"
                      />
                    </el-form-item>
                  </div>
                </el-col>
              </template>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">原产国</div>
                  <el-form-item prop="originCountry" label="">
                    <el-select
                      v-model="form.originCountry"
                      filterable
                      style="width: 100%"
                      size="small"
                      placeholder="请选择原产国"
                    >
                      <el-option
                        v-for="(item, index) in addressDropCodeOption"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">是否申报ISF</div>
                  <el-radio-group v-model="form.isDeclareISF" size="small">
                    <el-radio-button
                      :label="true"
                    >是</el-radio-button
                    >
                    <el-radio-button
                      :label="false"
                    >否</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">提货方式</div>
                  <el-radio-group v-model="form.pickUpType" size="small" @input="form.deliveryType = 1; form.code = ''">
                    <el-radio-button
                      v-for="item in tabItems2"
                      :key="item.id"
                      :label="item.id"
                    >{{ item.name }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </el-col>
              <template v-if="form.pickUpType === 1">
                <el-col :span="8">
                  <div class="field">
                    <div class="label">直送类型</div>
                    <el-radio-group
                      v-model="form.deliveryType"
                      size="small"
                      @input="form.code = ''"
                    >
                      <el-radio-button
                        v-for="item in tabItems3"
                        :key="item.id"
                        :label="item.id"
                      >{{ item.name }}</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="field">
                    <div class="label">
                      {{ form.deliveryType === 0 ? "快递商" : "仓库" }}
                    </div>
                    <el-form-item v-if="form.deliveryType !== 0" prop="code">
                      <el-select
                        v-model="form.code"
                        style="width: 220px"
                        filterable
                        clearable
                        size="small"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in warehouseList"
                          :key="item.label"
                          :label="item.label"
                          :value="item.label"
                        >
                          <span style="float: left">{{ item.label }}</span>
                          <span
                            style="
                              float: right;
                              color: #8492a6;
                              font-size: 13px;
                            "
                          >
                            {{ item?.addressLine1 | formatStatusAddress }}
                            {{ item?.addressLine2 | formatStatusAddress }}
                            {{ item?.city | formatStatusAddress }}
                            {{ item?.state | formatStatusAddress }}
                            {{ item?.countryCode | formatStatusAddress }}
                            <strong>{{
                              item?.postalCode ? item?.postalCode : ""
                            }}</strong>
                          </span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-else prop="expressSupplier">
                      <div class="supplyList" style="width: 220px">
                        <div
                          v-for="(
                            item, $index
                          ) in config.expressSupplierOptions"
                          :key="item.value"
                          class="item"
                          :class="{ active: kdSupplyIndex === $index }"
                          @click="kdSupplyIndex = $index"
                        >
                          <img
                            :src="require(`@/assets/images/serverSupply/${item.value.toLowerCase()}.png`)"
                            class="logoUrl"
                          />
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </template>
            </el-row>
            <el-row v-if="form.pickUpType === 2 && form.clearenceType === 1">
              <el-col :span="8">
                <div class="field">
                  <div class="label">清关模式</div>
                  <el-form-item prop="clearanceMode">
                    <el-select
                      v-model="form.clearanceMode"
                      style="width: 220px"
                      filterable
                      clearable
                      size="small"
                      :disabled="form.status"
                      placeholder="请选择清关模式"
                    >
                      <el-option
                        v-for="item in config.clearanceModesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>

                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">卸货港</div>
                  <el-form-item prop="dischargeHarbor">
                    <el-select
                      v-model="form.dischargeHarbor"
                      filterable
                      placeholder="请选择"
                      size="small"
                      style="width: 220px"
                    >
                      <el-option
                        v-for="(item, $index) in destinPortOptions"
                        :key="$index"
                        :label="item.label"
                        :value="item.label"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">卸货港日期</div>
                  <el-form-item prop="dischargeHarborDate">
                    <el-date-picker
                      v-model="form.dischargeHarborDate"
                      type="datetime"
                      size="small"
                      placeholder="请选择到卸货港日期"
                      style="width: 220px"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <template v-if="rowData.status > 0">
              <el-row>
                <el-col v-if="form.clearenceType" :span="8">
                  <div class="field">
                    <div class="label">清关行</div>
                    <el-form-item prop="supplierClearenceId">
                      <el-select
                        v-model="form.supplierClearenceId"
                        filterable
                        style="width: 220px"
                        size="small"
                      >
                        <el-option
                          v-for="item in clearenceOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col v-if="form.pickUpType" :span="8">
                  <div class="field">
                    <div class="label">提货车行</div>
                    <el-form-item prop="supplierId">
                      <el-select
                        v-model="form.supplierId"
                        filterable
                        style="width: 220px"
                        size="small"
                      >
                        <el-option
                          v-for="item in pickUpOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col v-if="form.pickUpType === 2" :span="8">
                  <div class="field">
                    <div class="label">拆柜供应商</div>
                    <el-form-item prop="supplierUnstuffingId">
                      <el-select
                        v-model="form.supplierUnstuffingId"
                        filterable
                        style="width: 220px"
                        size="small"
                      >
                        <el-option
                          v-for="item in unstuffingOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </template>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">客户名称</div>
                  <el-form-item prop="companyId">
                    <el-select
                      v-model="form.companyId"
                      filterable
                      style="width: 220px"
                      size="small"
                      placeholder="请选择客户"
                    >
                      <el-option
                        v-for="(item, $index) in companyDrapdown"
                        :key="$index"
                        :label="item.label"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <!-- <el-date-picker
                      v-model="form.companyId"
                      type="datetime"
                      placeholder="请选择到卸货港日期"
                      value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker> -->
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
          <div v-if="rowData.status > 0" class="panel2">
            <div class="panel-title">
              <div class="panel-titleInfo">
                <div>
                  <svg-icon
                    iconClass="panelTitle-icon"
                    className="icon"
                    :style="{ 'font-size': 20 }"
                  />
                  跟进人信息
                </div>
              </div>
            </div>
            <el-row>
              <el-col :span="8">
                <div class="field">
                  <div class="label">操作</div>
                  <el-form-item prop="operator">
                    <el-select
                      v-model="form.operator"
                      multiple
                      filterable
                      size="small"
                      placeholder="请选择"
                      style="width: 220px"
                    >
                      <el-option
                        v-for="item in operatorOptions"
                        :key="item.id"
                        :label="item.nameCH"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">客服</div>
                  <el-form-item prop="customer">
                    <el-select
                      v-model="form.customer"
                      multiple
                      filterable
                      size="small"
                      placeholder="请选择"
                      style="width: 220px"
                    >
                      <el-option
                        v-for="item in customerOptions"
                        :key="item.id"
                        :label="item.nameCH"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="field">
                  <div class="label">财务</div>
                  <el-form-item prop="financer">
                    <el-select
                      v-model="form.financer"
                      multiple
                      filterable
                      size="small"
                      placeholder="请选择"
                      style="width: 220px"
                    >
                      <el-option
                        v-for="item in financerOptions"
                        :key="item.id"
                        :label="item.nameCH"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <template v-if="!billType">
          <div
            v-for="(item, $index) in form.containers"
            :key="$index"
            class="panel2"
          >
            <div class="panel-title">
              <div class="panel-titleInfo">
                <div>
                  <svg-icon
                    iconClass="panelTitle-icon"
                    className="icon"
                    :style="{ 'font-size': 20 }"
                  />
                  柜子信息
                </div>
              </div>
            </div>
            <el-form
              :ref="`containerInfo${$index}`"
              :model="item"
              :rules="rules2"
              label-position="top"
            >
              <div>
                <el-row>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">柜号</div>
                      <el-form-item prop="containerNumber">
                        <el-input
                          v-model="item.containerNumber"
                          placeholder="仅限输入数字和英文字符"
                          style="width: 220px"
                          size="small"
                          :maxlength="11"
                          oninput="value=value.replace(/[^0-9a-zA-Z]/g, '')"
                        >
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">柜型</div>
                      <el-form-item prop="containertypeName">
                        <el-select
                          v-model="item.containertypeName"
                          filterable
                          style="width: 220px"
                          size="small"
                          placeholder="请选择柜型"
                        >
                          <el-option
                            v-for="(op, opi) in config.containertypeOptions"
                            :key="opi"
                            :label="op.label"
                            :value="op.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">船名</div>
                      <el-form-item prop="vesselName">
                        <el-select
                          v-model="item.vesselName"
                          style="width: 220px"
                          filterable
                          size="small"
                          allow-create
                          placeholder="请选择船名"
                          default-first-option
                        >
                          <el-option
                            v-for="vesselName in vesselNameOptions"
                            :key="vesselName.value"
                            :label="vesselName.label"
                            :value="vesselName.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">船次/航次</div>
                      <el-form-item prop="voyageNo">
                        <el-input
                          v-model="item.voyageNo"
                          size="small"
                          style="width: 220px"
                          placeholder="请输入船次/航次"
                          @input="onInput('voyageNo')"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">航线</div>
                      <el-form-item prop="routeLine">
                        <el-input
                          v-model="item.routeLine"
                          style="width: 220px"
                          size="small"
                          placeholder="请输入"
                          @input="onInput('routeLine')"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">封条号</div>
                      <el-form-item prop="sealNumber">
                        <el-input
                          v-model="item.sealNumber"
                          size="small"
                          placeholder="请输入封条号"
                          style="width: 220px"
                        >
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">提单件数(件)</div>
                      <el-form-item prop="qty">
                        <el-input
                          v-model="item.qty"
                          style="width: 220px"
                          size="small"
                          placeholder="请输入提单件数"
                          @input="onInput('qty')"
                        >
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">方数(CBM)</div>
                      <el-form-item prop="weightCbm">
                        <el-input
                          v-model="item.weightCbm"
                          style="width: 220px"
                          size="small"
                          placeholder="请输入方数"
                          @input="onInput('weightCbm')"
                        >
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="field">
                      <div class="label">重量(KG)</div>
                      <el-form-item prop="weightKgs">
                        <el-input
                          v-model="item.weightKgs"
                          size="small"
                          style="width: 220px"
                          placeholder="请输入重量"
                          @input="onInput('weightKgs')"
                        >
                        </el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
        </template>
        <div class="panel-btn-content">
          <div class="panel-btn" @click="ok('billInfo')">
            <img src="@/assets/images/bill/track.png" />
            确定修改
          </div>
        </div>
      </div>
      <!-- </el-form> -->
    </div>
  </Drawer>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')

import config from '@/utils/config'
import { mapGetters } from 'vuex'
import { debounce, insertStr } from '@/utils/common'
import { getSupplierDropDownList, getUserForType } from '@/api/system'
import { existsMBL, modifyMBL, mblModifyInfo } from '@/api/bill'
import { getVesselNameList, getScinList } from '@/api/basic'
import { getImporterDrapdown } from '@/api/system'
export default {
  components: { Drawer },
  filters: {
    formatStatusAddress(val) {
      return val ? val + ',' : ''
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    billType: {
      type: Number,
      default: 0
    }
  },
  data() {
    const validateMblNo = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入主单号'))
      } else {
        if (this.billType && value.length !== 12) {
          callback(new Error('主单号格式有误'))
        } else {
          this.checkMblNo(value, callback)
        }
      }
    }
    const validateContainerNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入柜号'))
      } else {
        if (value.length < 8) {
          callback(new Error('柜号长度必须大于8位'))
        } else {
          callback()
        }
      }
    }
    return {
      config,
      form: {
        transportName: '',
        mblNo: '',
        blNo: '',
        countryCode: 'US',
        originHarborName: '',
        destinationHarborName: '',
        date: [],
        shipperName: '',
        consigneeName: '',
        importerName: '',
        notifyPartyName: '',
        manufacturerName: '',
        ultimateConsigneeName: '',
        originCountry: '',
        qty: '',
        weightKgs: '',
        weightCbm: '',
        receivedDoEmail: '',
        receivedDoCompany: '',
        clearanceMode: '',
        containers: [
          {
            containerNumber: '',
            containertypeName: '20GP',
            sealNumber: '',
            routeLine: '',
            voyageNo: '',
            vesselName: ''
          }
        ],
        code: ''
      },
      tabItems2: [
        {
          name: '自提',
          id: 0
        },
        {
          name: '直送',
          id: 1
        },
        {
          name: '回仓',
          id: 2
        }
      ],
      tabItems3: [
        {
          name: '快递商',
          id: 0
        },
        {
          name: '亚马逊仓',
          id: 1
        },
        {
          name: '私仓',
          id: 2
        },
        {
          name: '沃尔玛仓',
          id: 5
        }
      ],
      active: '0',
      kdSupplyIndex: 0,
      loading: false,
      mblDetail: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      rules: {
        mblNo: [{ required: true, validator: validateMblNo, trigger: 'blur' }],
        companyId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        countryCode: [
          { required: true, message: '请选择目的国', trigger: 'change' }
        ],
        originCountry: [
          { required: true, message: '请选择原产国', trigger: 'change' }
        ],
        originHarborName: [
          { required: true, message: '请选择始发港', trigger: 'change' }
        ],
        destinationHarborName: [
          { required: true, message: '请选择目的港', trigger: 'change' }
        ],
        date: [{ required: true, message: '请选择ETD-ETA', trigger: 'change' }],
        qty: [{ required: true, message: '请输入提单件数', trigger: 'blur' }],
        weightKgs: [{ required: true, message: '请输入重量', trigger: 'blur' }],
        weightCbm: [{ required: true, message: '请输入方数', trigger: 'blur' }],
        shipperName: [
          { required: true, message: '请选择发货人', trigger: 'change' }
        ],
        consigneeName: [
          { required: true, message: '请选择收货人', trigger: 'change' }
        ],
        importerName: [
          { required: true, message: '请选择进口商', trigger: 'change' }
        ],
        notifyPartyName: [
          { required: true, message: '请选择通知方', trigger: 'change' }
        ],
        manufacturerName: [
          { required: true, message: '请选择制造商', trigger: 'change' }
        ],
        ultimateConsigneeName: [
          { required: true, message: '请选择最终收货人', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        clearanceMode: [
          { required: true, message: '请选择清关模式', trigger: 'change' }
        ]
        // vesselName: [
        //   { required: true, message: '请选择船名', trigger: 'change' }
        // ],
        // voyageNo: [
        //   { required: true, message: '请选择船次/航次', trigger: 'change' }
        // ]
      },
      rules2: {
        containerNumber: [
          {
            required: true,
            validator: validateContainerNumber,
            trigger: 'blur'
          }
        ],
        containertype: [
          { required: true, message: '请选择柜型', trigger: 'change' }
        ],
        vesselName: [
          { required: true, message: '请选择船名', trigger: 'change' }
        ],
        // routeLine: [
        //   { required: true, message: '请选择航线', trigger: 'change' }
        // ],
        voyageNo: [
          { required: true, message: '请选择船次/航次', trigger: 'change' }
        ]
      },
      pickUpOptions: [],
      clearenceOptions: [],
      unstuffingOptions: [],
      userOptions: [],
      vesselNameOptions: [],
      scinList: [],
      importerList: []
    }
  },
  computed: {
    ...mapGetters([
      'addressDropOption',
      'addressBookOptions',
      'shipTransportOptions',
      'airTransportOptions',
      'shipOrginPortOptions',
      'airOrginPortOptions',
      'airDestinPortOptions',
      'shipDestinPortOptions',
      'companyDrapdown'
    ]),
    operatorOptions() {
      const arr = [200, 2001, 266]
      return this.userOptions?.filter((a) => arr.includes(a.type))
    },
    financerOptions() {
      const arr = [266, 201, 202, 203]
      return this.userOptions?.filter((a) =>
        arr.includes(a.type)
      )
    },
    customerOptions() {
      const arr = [266, 1801, 180]
      return this.userOptions?.filter((a) => arr.includes(a.type))
    },
    addressDropCodeOption() {
      return this.addressDropOption.map((item) => {
        return {
          value: item.regionCode,
          label: `${item.label}`
        }
      })
    },
    transportOptions() {
      return this.billType
        ? this.airTransportOptions
        : this.shipTransportOptions
    },
    orginPortOptions() {
      return this.billType
        ? this.airOrginPortOptions
        : this.shipOrginPortOptions
    },
    destinPortOptions() {
      const portOptions = this.billType
        ? this.airDestinPortOptions
        : this.shipDestinPortOptions
      const arr = portOptions?.filter((a) => a.code === this.form.countryCode)
      return arr
    },
    shipperOptions() {
      console.log(this.scinList)
      return this.scinList
        ?.filter((a) => a.type.indexOf(0) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    consigneeOptions() {
      console.log(this.scinList)
      return this.scinList
        ?.filter((a) => a.type.indexOf(1) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    notifyPartyOptions() {
      return this.scinList
        ?.filter((a) => a.type.indexOf(3) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    manufacturerOptions() {
      return this.scinList
        ?.filter((a) => a.type.indexOf(4) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    ultimateConsigneeOptions() {
      return this.scinList
        ?.filter((a) => a.type.indexOf(5) > -1)
        .map((item) => {
          item.label = item.name
          return item
        })
    },
    // 亚马逊仓
    AMZWarehouseList() {
      return (
        this.addressBookOptions[this.rowData.companyId] ||
        this.addressBookOptions[0]
      )
        .filter((a) => a.type === 1)
        .map((item) => {
          item.label = `${item.code}`
          return item
        })
    },
    // 沃尔玛仓
    WrmWarehouseList() {
      return (
        this.addressBookOptions[this.rowData.companyId] ??
        this.addressBookOptions[0] ??
        []
      )
        .filter((a) => a.type === 100)
        .map((item) => {
          item.label = `${item.code}`
          return item
        })
    },
    warehouseList() {
      const companyWarehouseList = (
        this.addressBookOptions[this.rowData.companyId] ||
        []
      ).filter((a) => a.type === 0)

      const arr = companyWarehouseList.map((item) => {
        item.label = `${item.code}`
        return item
      })

      if (this.form.deliveryType === 1) {
        return this.AMZWarehouseList
      } else if (this.form.deliveryType === 5) {
        return this.WrmWarehouseList
      } else {
        return arr
      }
    },
    mblHandlers() {
      const operator =
        this.mblDetail.mblHandlers
          ?.filter((a) => a.type === 0)
          .map((a) => a.userName)
          .join(',') || '无'
      const customer =
        this.mblDetail.mblHandlers
          ?.filter((a) => a.type === 2)
          .map((a) => a.userName)
          .join(',') || '无'
      const financer =
        this.mblDetail.mblHandlers
          ?.filter((a) => a.type === 1)
          .map((a) => a.userName)
          .join(',') || '无'
      return {
        operator,
        customer,
        financer
      }
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        // this.$store.dispatch('getAddressBookOptions', {
        //   type: -1
        // })
        this.getUserForType()
        this.getSupplyList()
        this.getScinData()
        this.getImporterData()
        this.getMblDetail()
      }
    }
  },
  mounted() {
    if (!(this.addressDropOption && this.addressDropOption.length > 0)) {
      this.$store.dispatch('getAddress')
    }
    if (!(this.addressBookOptions && this.addressBookOptions.length > 0)) {
      this.$store.dispatch('getAddressBookOptions', {
        type: -1,
        companyId: 0
      })
    }
    if (!(this.shipTransportOptions && this.shipTransportOptions.length > 0)) {
      this.$store.dispatch('getShipTransportOptions')
    }
    if (!(this.airTransportOptions && this.airTransportOptions.length > 0)) {
      this.$store.dispatch('getAirTransportOptions')
    }
    if (!(this.shipOrginPortOptions && this.shipOrginPortOptions.length > 0)) {
      this.$store.dispatch('getShipOrginPortOptions')
    }
    if (!(this.airOrginPortOptions && this.airOrginPortOptions.length > 0)) {
      this.$store.dispatch('getAirOrginPortOptions')
    }
    if (
      !(this.shipDestinPortOptions && this.shipDestinPortOptions.length > 0)
    ) {
      this.$store.dispatch('getShipDestinPortOptions')
    }
    if (!(this.airDestinPortOptions && this.airDestinPortOptions.length > 0)) {
      this.$store.dispatch('getAirDestinPortOptions')
    }
    if (!(this.companyDrapdown && this.companyDrapdown.length > 0)) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    async getScinData() {
      try {
        const res = await getScinList()
        if (res.success) {
          this.scinList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getImporterData() {
      try {
        const res = await getImporterDrapdown({ status: 4 })
        if (res.success) {
          this.importerList = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    close() {
      this.$emit('close')
    },
    // 验证主单号
    checkMblNo: debounce(function(value, callback) {
      if (value === this.rowData.mblNo) {
        return callback()
      }
      const param = {
        blNo: value,
        isExietsBlNO: true
      }
      existsMBL(param).then((res) => {
        if (res.success) {
          callback(new Error('提单号已存在，请重新输入'))
          this.$message.error('提单号已存在，请重新输入')
        } else {
          callback()
        }
      })
    }, 500),
    async getUserForType() {
      try {
        const res = await getUserForType({})
        if (res.success) {
          this.userOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getSupplyList() {
      try {
        const result1 = await getSupplierDropDownList({
          scopValue: 19,
          isActived: true
        })
        if (result1.success) {
          this.pickUpOptions = result1.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          )
        } else {
          this.$message.error(result1.errorMessage)
        }
        const result2 = await getSupplierDropDownList({
          scopValue: 18,
          isActived: true
        })
        if (result2.success) {
          this.clearenceOptions = result2.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          )
        } else {
          this.$message.error(result2.errorMessage)
        }
        const result3 = await getSupplierDropDownList({
          scopValue: 20,
          isActived: true
        })
        if (result3.success) {
          this.unstuffingOptions = result3.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          )
        } else {
          this.$message.error(result3.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getVesselNameList() {
      try {
        const res = await getVesselNameList()
        if (res.success) {
          this.vesselNameOptions = res.data.map((a) => {
            return {
              value: a.vesselName,
              label: a.vesselName
            }
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getMblDetail() {
      try {
        this.loading = true
        const res = await mblModifyInfo({ mblId: this.rowData.id })
        this.loading = false
        if (res.success) {
          const operator = res.data.users
            ?.filter((a) => a.type === 0)
            .map((a) => a.userId)
          const customer = res.data.users
            ?.filter((a) => a.type === 2)
            .map((a) => a.userId)
          const financer = res.data.users
            ?.filter((a) => a.type === 1)
            .map((a) => a.userId)
          let code = ''
          if (res.data.directDelivery?.wareHouse?.code.indexOf(' ') > -1) {
            code = res.data.directDelivery?.wareHouse?.code.split(' ')[1]
          } else {
            code = res.data.directDelivery?.wareHouse?.code
          }
          this.form = {
            ...res.data,
            companyId: res.data.companyId.toString(),
            date: [res.data.etd, res.data.eta],
            deliveryType: res.data.directDelivery?.deliveryType !== undefined ? res.data.directDelivery?.deliveryType : '',
            kdSupplyIndex: res.data.directDelivery?.express?.expressSupplier,
            code: `${code}${res.data.directDelivery?.wareHouse?.companyName ? `-${res.data.directDelivery?.wareHouse?.companyName}` : ''}`,
            operator,
            customer,
            financer,
            isDeclareISF: this.rowData.isDeclareISF || false,
            shipperName: res.data.mblScinList.find(a => a.type === 0)?.scin?.name,
            consigneeName: res.data.mblScinList.find(a => a.type === 1)?.scin?.name,
            importerName: res.data.mblScinList.find(a => a.type === 2)?.importer?.name,
            notifyPartyName: res.data.mblScinList.find(a => a.type === 3)?.scin?.name,
            manufacturerName: res.data.mblScinList.find(a => a.type === 4)?.scin?.name,
            ultimateConsigneeName: res.data.mblScinList.find(a => a.type === 5)?.scin?.name
          }
          this.changeMblNo()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (erroe) {
        console.error(erroe)
      }
    },
    onInput(type) {
      type === 'mblNo' &&
        this.$set(
          this.form,
          'mblNo',
          this.form.mblNo.replace(/[^A-Za-z0-9-]/g, '').toUpperCase()
        )
      type === 'blNo' &&
        this.$set(
          this.form,
          'blNo',
          this.form.blNo.replace(/[^A-Za-z0-9-]/g, '').toUpperCase()
        )
      type === 'routeLine' &&
        this.$set(
          this.form,
          'routeLine',
          this.form.routeLine.replace(/[^\da-zA-Z\+]/g, '')
        )
      type === 'voyageNo' &&
        this.$set(
          this.form,
          'voyageNo',
          this.form.voyageNo.replace(/[^\da-zA-Z\-]/g, '')
        )
      type === 'qty' &&
        this.$set(this.form, 'qty', this.form.qty.replace(/[^\d]/g, ''))
      type === 'weightCbm' &&
        this.$set(
          this.form,
          'weightCbm',
          this.form.weightCbm.replace(/[^\d.]/g, '')
        )
      type === 'weightKgs' &&
        this.$set(
          this.form,
          'weightKgs',
          this.form.weightKgs.replace(/[^\d.]/g, '')
        )
    },
    changeMblNo() {
      if (!this.form.mblNo) {
        return false
      }
      if (this.billType && this.form.mblNo[3] !== '-') {
        this.form.mblNo = insertStr(this.form.mblNo, 3, '-', true)
      }
      const str = this.billType
        ? this.form.mblNo.slice(0, 3)
        : this.form.mblNo.slice(0, 4)
      const item =
        str && this.transportOptions.find((a) => a.label.indexOf(str) > -1)
      if (item) {
        this.form.transportName = item.label
      }
      // this.getStaging(this.form.mblNo)
    },

    ok(formName) {
      if (this.form.clearenceType === 0 && this.form.pickUpType === 0) {
        this.$message.error('禁止自清自提组合')
        return false
      }
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          if (
            this.form.mblNo.indexOf(this.form.transportName.split('-')[0]) !== 0
          ) {
            this.$message.warning(
              `提单号必须${this.billType ? '航空' : '船'}公司公司代码开头`
            )
            return
          }
          const operator = this.form.operator.map((a) => {
              return {
                userId: a,
                userName: this.operatorOptions.find(b => b.id === a)?.nameCH,
                type: 0
              }
            })?.filter(a => a.userName)
            const customer = this.form.customer.map((a) => {
              return {
                userId: a,
                userName: this.customerOptions.find(b => b.id === a)?.nameCH,
                type: 2
              }
            })?.filter(a => a.userName)
            const financer = this.form.financer.map((a) => {
              return {
                userId: a,
                userName: this.financerOptions.find(b => b.id === a)?.nameCH,
                type: 1
              }
            })?.filter(a => a.userName)
            const containers = this.form.containers.map(a => {
              return {
                ...a,
                containertype: a.containertypeName
              }
            })
            let directDelivery
            if (this.form.pickUpType === 1) {
              let warehouse
              if (this.form.deliveryType) {
                warehouse = this.warehouseList.find(
                  (a) => a.code === this.form.code.split('-')[0]
                )
              }
              directDelivery = {
                  deliveryType: this.form.deliveryType,
                  wareHouse: this.form.code && this.form.deliveryType !== 0 ? {
                        ...warehouse
                      }
                  : undefined,
                  express: this.form.deliveryType === 0 ? {
                    expressSupplier: this.config.expressSupplierOptions[this.kdSupplyIndex]?.value
                  } : undefined
              }
            }
          const param = {
            ...this.form,
            mblId: this.rowData.id,
            etd: this.form.date[0],
            eta: this.form.date[1],
            users: [...operator, ...customer, ...financer],
            mblScinList: [{
              scin: this.consigneeOptions.find(a => a.name === this.form.consigneeName),
              type: 1
            }, {
              scin: this.shipperOptions.find(a => a.name === this.form.shipperName),
              type: 0
            }, {
              scin: this.notifyPartyOptions.find(a => a.name === this.form.notifyPartyName),
              type: 3
            }, {
              scin: this.manufacturerOptions.find(a => a.name === this.form.manufacturerName),
              type: 4
            }, {
              scin: this.ultimateConsigneeOptions.find(a => a.name === this.form.ultimateConsigneeName),
              type: 5
            }, {
              importer: this.importerList.find(a => a.name === this.form.importerName),
              type: 2
            }],
            containers,
            directDelivery
          }
          const res = await modifyMBL(param)
          if (res.success) {
            this.$message.success('修改成功')
            this.$emit('ok')
          } else {
            this.$message.error(res.errorMessage)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.closeIcon {
  font-size: 20px;
  cursor: pointer;
}
.view {
  width: 100%;
  height: 100%;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  overflow-y: hidden;
  &:deep(.fTable) {
    .fp-cell {
      border: 0;
    }
  }
  &:deep(.el-form-item__content) {
    height: 30px;
    line-height: 30px;
  }
  &:deep(.el-form-item) {
    margin-bottom: 0px;
  }
  &:deep(.el-row + .el-row) {
    margin-top: 16px;
  }
  &:deep(.el-input--small .el-input__inner) {
    height: 30px;
    line-height: 30px;
  }
  &:deep(.el-input--small) {
    display: flex;
  }
  &:deep(.el-select) {
    display: flex;
  }
  &:deep(.el-range-editor--small.el-input__inner) {
    height: 30px;
  }
  .label {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    background: #e9ecf3;
    border-radius: 4px;
    font-size: 14px;
    color: #142e79;
  }
  .panelActive1 {
    .label {
      width: 140px;
      margin-right: 8px;
    }
  }
  .tag {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #f7f7f7;
    padding-right: 20px;
    box-sizing: border-box;
    &:deep(.el-tabs__header) {
      margin: 15px 0;
    }
    &:deep(.el-tabs--card > .el-tabs__header) {
      border-bottom: 0;
    }
    &:deep(.el-tabs__nav) {
      border: 0;
    }
    &:deep(.el-tabs__item) {
      height: 24px;
      line-height: 24px;
      border: 0;
    }
    &:deep(.el-tabs__item.is-active) {
      color: rgb(18, 88, 188);
    }
  }
  .panle-container {
    width: 100%;
    height: auto;
    border-radius: 6px 6px 6px 6px;
    .table-header {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #f7f7f7;
      border-radius: 4px 4px 0px 0px;
      border: 1px solid #eeeeee;
      border-bottom: 0;
      box-sizing: border-box;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .markbox {
      display: inline-block;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      .mark-label {
        width: auto;
        height: 24px;
        border-radius: 4px 4px 4px 4px;
        margin-right: 4px;
        padding: 0 6px;
      }
      .mark-info {
        color: #333333;
      }
      .green {
        color: #35ba83;
        background: rgba(53, 186, 131, 0.1);
      }
      .red {
        color: #fe453d;
        background: rgba(254, 69, 61, 0.1);
      }
      & + .markbox {
        margin-left: 24px;
      }
    }
  }
  .supplyList {
    width: 100%;
    height: 30px;
    display: flex;
    .item {
      width: 100px;
      height: 30px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      border: 1px solid #dbe4f2;
      text-align: center;
      position: relative;
      cursor: pointer;
      & + .item {
        margin-left: 16px;
      }
      .logoUrl {
        max-width: 100px;
        max-height: 27px;
        padding-top: 1px;
      }
    }
    .active {
      border: 1px solid rgb(18, 88, 188);
      &::before {
        content: " ";
        width: 0;
        height: 0;
        background: transparent;
        border-top: 13px solid rgb(18, 88, 188);
        border-right: 13px solid rgb(18, 88, 188);
        border-bottom: 13px solid transparent;
        border-left: 13px solid transparent;
        opacity: 1;
        position: absolute;
        top: -1px;
        left: 72px;
        z-index: 1;
      }
      &::after {
        content: " ";
        width: 15px;
        height: 9px;
        background-image: url("~@/assets/images/gou.png");
        background-repeat: no-repeat;
        background-size: 75%;
        position: absolute;
        top: 2px;
        left: 85px;
        z-index: 2;
      }
    }
  }
  .panel {
    width: 100%;
    height: calc(100vh - 204px);
    margin: 20px auto 0;
    padding: 0 40px 20px;
    box-sizing: border-box;
    overflow-y: auto;
    .panel-title {
      position: relative;
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 17px;
      svg {
        margin-right: 8px;
      }
      .panel-titleInfo {
        display: flex;
        align-items: center;
        & > div:first-child {
          display: flex;
          align-items: center;
        }
        .roughly {
          display: flex;
          margin-left: 15px;
          .roughly-item {
            display: flex;
            align-items: center;
            & > span:first-child {
              width: 40px;
              height: 24px;
              background: rgba(38, 152, 245, 0.1);
              border-radius: 4px 4px 4px 4px;
              font-size: 12px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              color: rgb(18, 88, 188);
            }
            & > span:last-child {
              margin-left: 5px;
            }
            & + .roughly-item {
              margin-left: 15px;
            }
          }
        }
      }
      .open {
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 24px;
        background: rgba(37, 151, 244, 0.1);
        border-radius: 4px 4px 4px 4px;
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: rgb(18, 88, 188);
        cursor: pointer;
      }
    }
  }
  .panel2 {
    margin-bottom: 24px;
  }
  .panel3 {
    width: 100%;
  }
  .typeName {
    display: flex;
    justify-content: space-between;
  }
  .field {
    width: 100%;
    height: auto;
    display: flex;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .field {
    p {
      flex: 1;
      height: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 30px;
    }
  }
  .panel-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid rgb(18, 88, 188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    cursor: pointer;
    & + .panel-btn {
      margin-left: 20px;
    }
    img {
      margin-right: 8px;
    }
  }
  .panel-btn-content {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 40px auto 0;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
  }
}
</style>
